export const PERIOD = Object.freeze({
  day: "day",
  week: "week",
  month: "month",
});

export const CURRENT_DATE = new Date().toISOString().substr(0, 10);

export default {};
